import type { ProductDetailPageGalleryItem } from '~/scopes/product-core/components/presentationals/ProductDetailPageGallery/ProductDetailPageGallery.types'

type GalleryItemKeyContext = 'mobile' | 'desktop'

export function getItemKey(
  item: ProductDetailPageGalleryItem,
  index: number,
  context: GalleryItemKeyContext,
): string {
  if (item.kind === 'image') {
    return `${context}-image-${item.image.id}`
  }

  if (item.kind === 'video') {
    return `${context}-video-${item.video.id}`
  }

  if (item.kind === 'skeleton') {
    return `${context}-skeleton-${index}`
  }

  return `${context}-review-${item.review.id}-${index}`
}
